<template>
<div class="container-fluid bg-white">
	<equipment-toolbar heading="Maintenance Schedule">
		<equipment-list-nav-tabs></equipment-list-nav-tabs>
	</equipment-toolbar>

	<collapsible-panel :external-toggle="panelToggle" v-on:panelRetract="panelToggle = false">

		<template slot="panel">

			<h4>Filtering</h4>
			
			<field label="By Event Type"
				col-class="stacked"
				v-model="filters.eventTypes"
				:params="{type:'select-multi',options:eventTypeOptions}">
			</field>

			<field label="By Equipment Category"
				col-class="stacked"
				v-model="filters.equipmentCategories"
				:params="{type:'select-multi',options:equipmentCategoryOptions}">
			</field>

			<field label="By Equipment Type"
				col-class="stacked"
				v-model="filters.equipmentTypes"
				:params="{type:'select-multi',options:equipmentTypeOptions}">
			</field>

			<field label="By Specific Equipment"
				col-class="stacked"
				v-model="filters.equipment"
				:params="{type:'select-multi',options:equipmentOptions}">
			</field>

			
		</template>
		<template slot="main">

			<div class="d-flex flex-row align-items-center pt-3 pb-2 button-row" style="margin-top: -15px;">

				<button 
					class="btn btn-light mr-2" 
					v-on:click="openFilterPanel">
					<i class="fa fa-filter"></i>
					Filter
				</button>

			</div>

			<div v-if="filteredEquipmentWithReminders.length > 0" class="table-matrix">
				<div class="left-column flex-table" :class="{'filtering-open': panelToggle}">

					<div class="flex-table-header">
						<div class="flex-table-row">
							<div class="flex-table-cell">
								<div class="header-cell-inner left-column-header">
									Equipment
								</div>
							</div>
						</div>
					</div>

					<div class="flex-table-body" ref="leftColumnBody">
						<div v-for="eqItem in filteredEquipmentWithReminders" class="flex-table-row">
							<div class="flex-table-cell header-cell"><router-link :to="'/equipment/item/'+eqItem.slug+'/maintenance-schedule'">{{eqItem.description}}</router-link></div>
						</div>
					</div>
				</div>
				<div class="main-table">
					<div class="flex-table" :style="{width: flexTableWidth}">

						<div class="flex-table-header">
							<div class="flex-table-row">
								<div v-for="event in filteredEvents" class="flex-table-cell" :title="event.title">
									<div class="header-cell-inner">
										<div class="header-cell-inner-2x">
											<div class="header-cell-inner-3x">{{ event.title }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="flex-table-body" ref="mainTable" v-on:scroll="scrollLeftColumn">
							<div v-for="eqItem in filteredEquipmentWithReminders" class="flex-table-row">
								<div class="flex-table-cell" v-for="reminder in eqItem.reminders">

									<div v-if="reminder.due_date" class="reminder-tile alert" :class="{
											'alert-success': daysUntil(reminder.due_date) >= reminder.warningIntervalDays,
											'alert-warning': daysUntil(reminder.due_date) < reminder.warningIntervalDays,
											'alert-danger': daysUntil(reminder.due_date) < reminder.dangerIntervalDays
										}">
										<router-link :to="'/equipment/item/' + eqItem.slug + '/maintenance-schedule/' + reminder.reminderSlug">

											<i class="fa" :class="{
												'fa-exclamation-triangle': daysUntil(reminder.due_date) < reminder.dangerIntervalDays,
												'fa-clock': daysUntil(reminder.due_date) < reminder.warningIntervalDays && daysUntil(reminder.due_date) > reminder.dangerIntervalDays,
												'fa-thumbs-up': daysUntil(reminder.due_date) >= reminder.warningIntervalDays
											}"></i>

											{{ daysUntil(reminder.due_date) }}d

										</router-link>
									</div>
								</div>
							</div>
							<div v-if="filteredEquipmentWithReminders.length == 0">
								In order to set up your maintenance schedule, create an event type in <rounter-link to="/equipment/settings">Equipment Settings</rounter-link>, and then add that event to your equipment.
							</div>
						</div>
					</div>
				</div>
			</div>
			<p v-else>In order to set up your equipment maintenance schedule, add a maintenance event type in <router-link to="/equipment/settings">Equipment Settings</router-link>, then add that event to a piece of equipment.</p>

		</template>

	</collapsible-panel>
</div>
</template>
<script type="text/javascript">
import EquipmentToolbar from "./EquipmentToolbar"	
import EquipmentListNavTabs from "./EquipmentListNavTabs"

import Field from "@/components/Field"

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

export default {
	name: "EquipmentMaintenanceSchedule",
	components: {
		EquipmentToolbar,
		EquipmentListNavTabs,
		CollapsiblePanel,
		Field
	},
	data() {
		return {
			eventTypes: [],
			maintenenceScheduleReminders: [],
			filters: {
				eventTypes: [],
				equipmentCategories: [],
				equipmentTypes: [],
				equipment: []
			},
			panelToggle: false,
			expiryDanger: 7,
			expiryWarning: 30,
		}
	},
	computed: {
		flexTableWidth() {
			return (window.innerWidth > 600) ? ((this.filteredEvents.length + 1) * 82) + 'px' : '100%'
		},
		filteredEvents() {
			return this.eventTypes.filter(type => this.filters.eventTypes.length == 0 || this.filters.eventTypes.indexOf(type.id) >= 0)
		},
		filteredEquipmentWithReminders() {
			let equipment = [], vm = this

			this.maintenenceScheduleReminders.forEach(reminder => {
				let eqMatch = equipment.find(eq => eq.id == reminder.equipment_id)

				if (!eqMatch)
					equipment.push(reminder.Equipment)
			})

			//now we need to add the full list of filtered reminders to each equipment
			let equipmentWithReminders = equipment.map(eq => {

				if (eq) {
					let eqReminders = []

					vm.filteredEvents.forEach(event => {
						let matchingReminder = vm.maintenenceScheduleReminders.find(reminder => reminder.equipment_id == eq.id && event.id == reminder.event_id)

						if (matchingReminder) {

							eqReminders.push({
								id: matchingReminder.id,
								due_date: matchingReminder.due_date,
								warningIntervalDays: +event.warning_interval_days,
								dangerIntervalDays: +event.danger_interval_days,
								reminderSlug: matchingReminder.slug
							})
						}
						else {
							eqReminders.push({
								id: null,
								due_date: null,
								warningIntervalDays: +event.warning_interval_days,
								dangerIntervalDays: +event.danger_interval_days,
								reminderSlug: null
							})
						}
					})

					eq.reminders = eqReminders

					let matchingEquipment = vm.$store.equipments.find(fullEq => fullEq.id == eq.id)

					if (matchingEquipment && "EquipmentType" in matchingEquipment)
						eq.EquipmentType = matchingEquipment.EquipmentType
				}

				return eq
			})

			equipmentWithReminders = equipmentWithReminders.filter(eq => {
				let include = true
				if (vm.filters.equipment.length > 0) {
					if (vm.filters.equipment.indexOf(eq.id) == -1)
						include = false
				}

				if (vm.filters.equipmentTypes.length > 0) {
					if (vm.filters.equipmentTypes.indexOf(eq.EquipmentType.id) == -1)
						include = false
				}

				if (vm.filters.equipmentCategories.length > 0) {
					if (vm.filters.equipmentCategories.indexOf(eq.EquipmentType.category_id) == -1)
						include = false
				}

				return include
			})

			return equipmentWithReminders
		},
		equipmentCategoryOptions() {
			return this.optionify(this.$store.equipmentCategories,"name")
		},
		eventTypeOptions() {
			return this.optionify(this.eventTypes,'title')
		}
	},
	methods: {
		scrollLeftColumn() {
			if ('leftColumnBody' in this.$refs) {

				this.$refs.leftColumnBody.style.marginTop = "-" + this.$refs.mainTable.scrollTop + "px"
			}
		},
		daysUntil(date) {
			return this.moment(date).diff(this.moment(),"days")
		},
		openFilterPanel() {
			let vm = this

			this.panelToggle = true

			if (this.$store.equipmentCategories.length == 0)
				this.fetchModel("EquipmentCategory","equipmentCategories",false)

			if (this.$store.equipmentTypes.length == 0)
				this.fetchEquipmentTypes()

			if (this.$store.equipments.length == 0)
				this.fetchEquipment()
		},
		fetchEventTypes() {
			let vm = this

			this.getJSON("EquipmentMaintenanceEventType/get").then(response => {
				if (response.success) {
					vm.eventTypes = response.data
				}
			})
		},
		fetchMaintenanceScheduleReminders() {
			let vm = this

			let params = {
				include: [
					{
						model: "Equipment",
						fields: ["description"]
					},
					{
						model: "EquipmentMaintenanceEventType",
						fields: ["warning_interval_days","danger_interval_days"]
					}
				]
			}

			this.getJSON("EquipmentMaintenanceEventReminder/get",params).then(response => {
				if (response.success) {
					vm.maintenenceScheduleReminders =  response.data
				}
			})
		}
	},
	created() {
		this.fetchEventTypes()
		this.fetchEquipment()
		this.fetchMaintenanceScheduleReminders()
		document.body.style.overflow = 'hidden'
	},
	destroyed() {
		document.body.style.overflow = 'auto'
	}
}
</script>

<style type="text/css" scoped>
	/*.cert-green {
		color: green;
	}

	.cert-warning {
		color: #ff8600;
	}

	.cert-danger {
		color: red
	}*/


	/* abandon all hope ye who enters */

	body {
		overflow: hidden;
	}

	.button-row {
		position: relative;
		z-index: 3;
		background-color: white;
	}

	.flex-table-body .flex-table-row .flex-table-cell {
		height: 28px;
		overflow: hidden;
		text-wrap: nowrap;
	}

	.table-matrix {
		display: block;
		overflow-y: hidden;
		overflow-x: hidden;
	}

	.left-column-header {
		display: flex;
		align-items: center;
		font-size: 11pt!important;
	}

	.left-column {
		min-width: 280px;
		width: 280px;
		position: absolute;
		left: 0;
		outline: white solid 2px;
		background-color: white;
		z-index: 2;
	}

	.left-column .flex-table-header {
		background-color: white;
		z-index: 2;
		position: relative;
	}

	.left-column .flex-table-body {
		z-index: 1;
		position: relative;
	}

	.filtering-open {
		margin-left: 280px;
	}

	.table-matrix .main-table {
		margin-left: 280px;
		margin-right: -15px;
		z-index: 1;
		overflow-x: auto;
	}

	.table-matrix .main-table .flex-table .flex-table-body {
		overflow-x: hidden;
		overflow-y: auto;
	}

	.flex-table-body {
		max-height: calc(100vh - 330px);
	}

	.flex-table-row {
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid #e0e0e0;
		align-items: stretch;
	}

	.flex-table-cell {
		flex-basis: 75px;
		flex-grow: 0;
		flex-shrink: 0;
		margin: 2px;
		display: flex;
    	align-items: center;
	}

	.flex-table-header .flex-table-cell.header-cell,
	.flex-table-cell.header-cell {
		flex-basis: 280px;
		border-right: none;
	}

	.flex-table-header, .header-cell {
		font-weight: 600;
	}

	.flex-table-header .flex-table-cell {
		flex-basis: 75px;
		width: 75px;
		border-right: none;
	}

	.flex-table-header .flex-table-cell .header-cell-inner {
		height: 150px;
		transform: translate(15px, -5px);
		font-size: 10pt;
	}

	.flex-table-header .flex-table-cell .header-cell-inner-2x {
		transform: rotate(-45deg);
		line-height: 1.1;
		border-bottom: 1px dotted #e0e0e0;
		width: 350px;
		margin-top: -5px;
	}

	.flex-table-header .flex-table-cell .header-cell-inner-3x {
		padding-bottom: 20px;
		position: relative;
		left: -25px;
	}

	.reminder-tile.alert {
		padding: 3px;
		box-shadow: 0 3px 1px -2px grey;
		border-radius: .25rem;
		border: 1px solid rgba(0,0,0,.125);
		width: 100%;
		margin-bottom: 0;
		font-size: 10pt;
	}

	.reminder-tile a {
		display: flex;
		flex-direction: row;
		color: inherit;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
	}

	.reminder-tile a i {
		margin-right: 5px;
	}

	.reminder-tile a:hover {
		text-decoration: none;
	}

	.reminder-tile .text-info {
		flex-grow: 1;
		text-align: center;
		font-size: 10pt;
	}

	.reminder-tile a .fa-external-link {
		display: none;
	}

	.reminder-tile a:hover .fa-external-link {
		display: inline;
	}


	@media (min-width: 800px) {

		.container-fluid {
			padding-right: 0;
		}

	}

	@media (max-width: 800px) {

		.table-matrix {
			display: flex;
			overflow-x: auto;
			overflow-y: hidden;
		}

		.left-column {
			position: relative;
		}

		.table-matrix .main-table {
			overflow-x: visible;
			margin-left: 0;
			width: 100%!important;
		}

		.flex-table-body {
			max-height: calc(100vh - 380px);
		}

		.filtering-open {
			margin-left: 0;
		}

		body {
			overflow-y: hidden;
			overflow-x: hidden;
		}
	}

</style>